import React, { useContext, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { AuthContext } from "../../context/Auth";
import { MdDelete, MdRemoveRedEye } from "react-icons/md";
import { BiSolidEdit } from "react-icons/bi";
import axios from "../../utils/Axios";
import { toast } from "react-toastify";

const DataTable = ({ searchTerm, setSearchTerm }) => {
  const { allModuleInfo, isEdited, setIsEdited } = useContext(AuthContext);
  const [selectedModule, setSelectedModule] = useState(null);

  const handleDelete = async (parentModuleName, childCardId, isParent) => {

    const toastId = toast(
      <div>
        <p>{isParent ? "Are you sure you want to delete this parent module?" : "Are you sure you want to delete this child card?"}</p>
        <div className="flex justify-end space-x-2">
          <button
            onClick={async () => {
              toast.dismiss(toastId);
              try {
                const response = await axios.delete("/pbi-dashbord/delete_child_card", {
                  data: { parentModuleName, childCardId, isParent },
                });

                if (response.status === 200) {
                  toast.success(isParent ? "Parent module deleted successfully" : "Child card deleted successfully");

                  if (isParent) {
                    setSelectedModule(null);
                  } else {
                    setSelectedModule((prev) => ({
                      ...prev,
                      childCards: prev.childCards.filter((card) => card.reportId !== childCardId),
                    }));
                  }

                  setIsEdited(!isEdited);
                } else {
                  toast.error("Failed to delete");
                }
              } catch (error) {
                console.error("Error during delete:", error);
                toast.error("Failed to delete");
              }
            }}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Yes
          </button>
          <button
            onClick={() => {
              toast.dismiss(toastId);
            }}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
        </div>
      </div>,
      { autoClose: false, closeOnClick: false }
    );
  };

  const filteredModules = allModuleInfo?.filter((module) => {
    const search = searchTerm.toLowerCase();
    return (
      module?.parentModuleName?.toLowerCase().includes(search) ||
      module?.pathName?.toLowerCase().includes(search) ||
      module?.cardStatus?.toLowerCase().includes(search) ||
      module?.childCards?.some((card) =>
        card?.childCardName?.toLowerCase().includes(search) ||
        card?.reportId?.toLowerCase().includes(search) ||
        card?.groupId?.toLowerCase().includes(search)
      )
    );
  });

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full mb-12 md:mb-0 table-auto border-collapse border border-gray-300">
        <thead className="bg-green-600 border text-white">
          <tr>
            <th className="px-6 py-3 coda-regular text-left border hidden md:flex font-light">Parent Module Name</th>
            <th className="px-6 py-3 coda-regular text-left border md:hidden font-light">Module</th>
            {/* <th className="px-6 py-3 coda-regular text-left border font-light">Path Name</th> */}
            <th className="px-6 py-3 coda-regular text-left border font-light">Card Status</th>
            <th className="px-6 py-3 coda-regular text-left border font-light">Child Cards</th>
            <th className="px-6 py-3 coda-regular text-left border font-light">Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredModules?.length > 0 ? (
            filteredModules?.map((module, index) => (
              <tr key={module._id} className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}>
                <td className="px-6 py-3 border border-gray-300">{module.parentModuleName}</td>
                {/* <td className="px-6 md:hidden py-3 border border-gray-300">{module.parentModuleName.length > 5 ? `${module.parentModuleName.slice(0, 5)}...` : module.parentModuleName}</td> */}
                {/* <td className="px-6  py-3 border border-gray-300">
                  {module.pathName.length > 0
                    ? module.pathName.length > 15
                      ? `${module.pathName.slice(0, 15)}...`
                      : module.pathName
                    : "Not Found"}
                </td> */}
                {/* <td className="px-6 py-3 md:hidden border border-gray-300">
                  {module.pathName.length > 0
                    ? module.pathName.length > 5
                      ? `${module.pathName.slice(0, 5)}...`
                      : module.pathName
                    : "Not Found"}
                </td> */}
                <td className="px-6 py-3 border border-gray-300">{module.cardStatus}</td>
                {/* <td className="px-6 py-3 border border-gray-300">{module.cardStatus.length > 7 ? `${module.cardStatus.slice(0, 7)}...` : module.cardStatus}</td> */}
                <td className="px-6 py-3 border border-gray-300">
                  {module?.childCards?.length > 0 ? (
                    <ul className="list-disc pl-5">
                      <li className="mb-2 flex gap-2">
                        <div>
                          <strong>Name:</strong> {module.childCards[0].childCardName.length > 10
                            ? `${module.childCards[0].childCardName.slice(0, 10)}...`
                            : module.childCards[0].childCardName}
                        </div>
                        <div className="md:flex hidden">
                          <strong>Report ID:</strong> {module.childCards[0].reportId.length > 10
                            ? `${module.childCards[0].reportId.slice(0, 10)}...`
                            : module.childCards[0].reportId}
                        </div>
                        <div className="md:flex hidden">
                          <strong>Group ID:</strong> {module.childCards[0].groupId.length > 10
                            ? `${module.childCards[0].groupId.slice(0, 10)}...`
                            : module.childCards[0].groupId}
                        </div>
                      </li>
                    </ul>
                  ) : (
                    <>
                      <span className="hidden md:flex">No Child Cards Available</span>
                      <span >Not Available</span>
                    </>
                  )}
                </td>
                <td className="px-6 border border-b-0 border-l-0 py-4  gap-2 flex border-gray-300">
                  <MdRemoveRedEye
                    size={24}
                    className="cursor-pointer p-1 text-green-500 bg-blue-100 rounded-full"
                    onClick={() => setSelectedModule(module)}
                  />
                  <MdDelete
                    onClick={() => handleDelete(module.parentModuleName, null, true)}
                    size={24}
                    className="cursor-pointer p-1 text-red-500 bg-blue-100 rounded-full"
                  />
                  <BiSolidEdit
                    size={24}
                    className="cursor-pointer hidden p-1 text-blue-500 bg-blue-100 rounded-full"
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center coda-regular px-6 py-3 bg-red-500/40 border border-gray-300">
                No Modules Found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {selectedModule && (
        <div
          className="fixed inset-0 flex items-center justify-center z-50 bg-gray-500 bg-opacity-50"
          onClick={() => setSelectedModule(null)}
        >
          <div
            className="bg-white h-[90vh] rounded overflow-y-auto shadow-lg md:w-[60vw] max-w-3xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="py-4 sticky z-40 top-0 px-6 bg-green-100">
              <div className="w-full flex justify-between items-center">
                <h3 className="text-lg coda-regular font-semibold text-gray-700 mb-4">
                  Module Details
                </h3>
                <div className="flex gap-4">
                  <IoCloseOutline
                    onClick={() => setSelectedModule(null)}
                    size={24}
                    className="cursor-pointer p-1 text-red-500 bg-blue-100 rounded-full"
                  />
                </div>
              </div>
              <p><strong>Parent Module Name:</strong> {selectedModule.parentModuleName}</p>
              <p><strong>Path Name:</strong> {selectedModule.pathName}</p>
              <p><strong>Card Status:</strong> {selectedModule.cardStatus}</p>
              <h4 className="font-medium text-gray-700 mt-4 ml-4 coda-regular">Child Cards :</h4>
            </div>
            <div className="list-disc p-4">
              {selectedModule.childCards.map((card) => (
                <div
                  key={card._id}
                  className="mb-2 border relative px-2 py-1 rounded bg-gray-50 border-gray-400"
                  style={{ cursor: "pointer" }}
                >
                  <div><strong>Name:</strong> {card.childCardName}</div>
                  {card.reportId != "hard_coded_123" && <> <div><strong>Report ID:</strong> {card.reportId}</div>
                    <div><strong>Group ID:</strong> {card.groupId}</div></>}
                  {card.url_looker != null && <div><strong>URL:</strong> {card.url_looker}</div>}

                  <MdDelete
                    onClick={() => handleDelete(selectedModule.parentModuleName, card.reportId, false)}
                    size={24}
                    className="cursor-pointer absolute top-1/2 transform -translate-y-1/2 right-2 p-1 text-red-500 bg-blue-100 rounded-full"
                  />
                </div>
              ))}
            </div>
            <p className="text-center text-red-500 flex coda-regular justify-center items-center w-full h-12 border-t">
              Thank You 🫡
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataTable;
